import { IMenu, TPublicationStatus } from 'src/types/menu.types';
import { Control, FieldValues, UseFormRegister, UseFormSetValue, UseFormWatch } from 'react-hook-form';

export interface IPublishVenue {
  name: string;
  venue_id: string;
  is_trial: boolean;
  priceSchemeName: string;
  publicationDate?: Date;
  publicationStatus?: TPublicationStatus;
}

export interface IPublishDestination {
  name: string;
  channel_id: string;
  publicationDate?: Date;
  publicationStatus?: TPublicationStatus;
  venues: IPublishVenue[];
}

export interface IModalProps {
  closeModal?: () => void;
  isOpen: boolean;
  menuId: string;
  menuName: string;
  isTrial?: boolean;
}

export enum PublishSteps {
  Mealtimes = 0,
  Scheme = 1,
  Channels = 2,
  DateTime = 3,
  Overview = 4,
}

export interface IPublishModalViewProps {
  onBackClick: () => void;
  onContinueClick: () => void;
}

export interface IPriceSchemeViewProps {
  control: Control<FieldValues>;
}

export interface IPublishViewProps {
  setValue: UseFormSetValue<FieldValues>;
  watch: UseFormWatch<FieldValues>;
  register: UseFormRegister<FieldValues>;
  publicationData: IPublishDestination[];
}

export interface ISelectedDestination extends IPublishModalViewProps {
  channel: string;
  channel_id: string;
  selected: boolean;
  selectedVenues: string[];
}

export interface IAdditionalMenuViewProps extends IPublishModalViewProps {
  selectableMenus: IMenu[];
  isTrial: boolean;
}
